// Saves generated text as a file in the browser (the console has no share sheet; iOS uses ShareLink).

export const CSV_MIME = 'text/csv;charset=utf-8';

// Written as an escape: a literal U+FEFF is invisible in an editor and easy for a formatter to strip unnoticed.
const UTF8_BOM = '﻿';

/**
 * The file's contents. CSV gets a byte-order mark so Excel reads it as UTF-8 (names with accents) instead of the
 * system code page; Numbers and Google Sheets ignore it. Pure, so the bytes are unit-tested.
 */
export function textFileBlob(text: string, mime: string = CSV_MIME): Blob {
  return new Blob(mime.startsWith('text/csv') ? [UTF8_BOM, text] : [text], { type: mime });
}

/** Starts a download of `text` named `fileName`. */
export function downloadText(fileName: string, text: string, mime: string = CSV_MIME): void {
  const url = URL.createObjectURL(textFileBlob(text, mime));
  const a = document.createElement('a');
  a.href = url;
  a.download = fileName;
  a.rel = 'noopener';
  a.style.display = 'none';
  document.body.appendChild(a);
  try {
    a.click();
  } finally {
    a.remove();
    // Revoking straight away can cancel the download in Safari; the blob is small and freed a minute later.
    window.setTimeout(() => URL.revokeObjectURL(url), 60_000);
  }
}
